module.exports = __webpack_public_path__ + "img/ALTS_logo_ru.7debb9a5.png";